module.exports = __webpack_public_path__ + "img/plus.87e33cb4.svg";